function getLoginPath() {
  return new Promise(resolve => {
    const commonSourceUrls = { otherSystem: false, path: dsf.config.setting_public_login_dialog };
    const sourceUrls = {
      ncIndex: commonSourceUrls,
      aliIndex: commonSourceUrls,
      xcIndex: commonSourceUrls,
      page: commonSourceUrls,
      index: commonSourceUrls,
      index1: commonSourceUrls,
      zxqyIndex: {
        otherSystem: true,
        path: "https://www.ssme.sh.gov.cn/login3_pop.jsp?platform=mcwlxy",
      },
    };
    const pages = ["ncIndex", "aliIndex", "xcIndex", "zxqyIndex", "page", "index1", "index"];
    const pageHtml = location.pathname.split("/") || [];
    // let sourceUrl = pageHtml.find(it => {});
    let sourceUrl = null;
    pageHtml.forEach(it => {
      if (it.includes(".html")) {
        let prefix = it.split(".")[0];
        if (pages.indexOf(prefix) > -1) {
          let path = sourceUrls[prefix];
          sessionStorage.setItem("loginPath", JSON.stringify(path));
          sourceUrl = sourceUrls[prefix];
        }
      }
    });
    if (sourceUrl) {
      resolve(sourceUrl);
    } else {
      let path = sessionStorage.getItem("loginPath");
      if (path) {
        sourceUrl = JSON.parse(path);
        resolve(sourceUrl);
      }
    }
  });
}

function checkLoginState(state = true) {
  let loginUrl = dsf.url.getMobileLogin();
  return new Promise(resolve => {
    if (dsf.getToken()) {
      resolve(true);
    } else {
      sessionStorage.clear();
      const isMobile = dsf.client.mobile();
      if (isMobile) {
        dsf.layer
          .confirm({ message: "当前操作需要登录, 去登录?", title: "提示", confirmButtonText: "是", cancelButtonText: "否" })
          .then(() => {
            dsf.cookies.set("registerSourceRoute", location.hash);
            location.replace(loginUrl);
          })
          .catch(() => {
            console.log("取消重新登录");
          });
        resolve(false);
      } else {
        getLoginPath().then(res => {
          let { otherSystem = false, path = dsf.config.setting_public_login_dialog } = res;
          console.log(res);
          if (otherSystem) {
            this.$open({
              url: path,
            });
          } else {
            this.$openDialog({
              title: "",
              width: "400px",
              height: dsf.config.setting_nc_tenement_wx_qrcode == "1" ? "400px" : "370px",
              noTitle: true,
              params: {
                path: path,
                loginSuccess() {
                  resolve(true);
                },
                loginFail() {
                  resolve(false);
                },
              },
              onClosed() {
                resolve(false);
              },
            });
          }
        });
        // let loginPath = sessionStorage.getItem("loginPath");
        // if (loginPath) {
        //   loginPath = JSON.parse(loginPath);
        //   openLogin(loginPath, this, resolve);
        // } else {
        //   getLoginPath().then(res => {
        //     openLogin(res, this, resolve);
        //   });
        // }
      }
    }
  });
}

export default checkLoginState;
